import {
  PSectionAgencies,
  PSectionAgencyLists,
  PSectionAnnouncements,
  PSectionBalanceRequests,
  PSectionBulkRatiosRequests,
  PSectionCustomers,
  PSectionDebtSendingSchedules,
  PSectionExpenses,
  PSectionFinancialRequests,
  PSectionInsuranceCompanies,
  PSectionInsuranceRequests,
  PSectionInvoices,
  PSectionLeads,
  PSectionMoneyAccounts,
  PSectionPaymentMethods,
  PSectionPayments,
  PSectionProfits,
  PSectionReports,
  PSectionServiceNames,
  PSectionServices,
  PSectionSettings,
  PSectionSmsMessages,
  PSectionSources,
  PSectionWhatsappDevices,
  PermissionAgenciesViewMainPageAll,
  PermissionAgenciesViewRatioHistory,
  PermissionReportAdvancedReports,
  PermissionReportAgenciesHasDebt,
  PermissionReportAgencyActivity,
  PermissionReportDiscountRates,
  PermissionReportInsuranceCompanies,
  PermissionSMSMessagesViewAll,
  PermissionSettingsViewBankInfo,
  PermissionWhatsappDevicesViewAll,
  PermissionsFinancialRequestsViewBillingProfileReport,
  PermissionsFinancialRequestsViewAgencyDiscountedPrices,
} from "./Permissions";
export const AppAdminMenu = (permissions, lang, is_super_admin) => {
  return [
    {
      path: "/home",
      title: window.sys_app_translate("Home", lang),
      subMenu: null,
      icon: "home",
    },
    permissions[PSectionInsuranceCompanies]["view-all"] ||
    permissions[PSectionInsuranceCompanies]["create"] ||
    permissions[PSectionInsuranceCompanies]["set-prices"]
      ? {
          path: "",
          title: window.sys_app_translate("Insurance Companies", lang),
          icon: PSectionInsuranceCompanies,
          subMenu: [
            permissions[PSectionInsuranceCompanies]["create"] && {
              title: window.sys_app_translate("Add Company", lang),
              path: "/insurance-companies/create",
            },
            permissions[PSectionInsuranceCompanies]["view-all"] && {
              title: window.sys_app_translate("Companies List", lang),
              path: "/insurance-companies/view-all",
            },
            permissions[PSectionInsuranceCompanies]["set-prices"] && {
              title: window.sys_app_translate("Insurance Prices", lang),
              path: "/insurance-companies/set-prices",
            },
          ],
          wrapWords: true,
        }
      : null,
    permissions[PSectionInsuranceRequests]["view-all"] ||
    permissions[PSectionInsuranceRequests]["create"]
      ? {
          path: PSectionInsuranceRequests,
          title: window.sys_app_translate("Insurances", lang),
          subMenu: null,
          icon: "insurances",
          subMenu: [
            permissions[PSectionInsuranceRequests]["create"]
              ? {
                  title: window.sys_app_translate("Create Insurance", lang),
                  path: "/insurance-requests/create",
                }
              : null,
            permissions[PSectionInsuranceRequests]["view-all"]
              ? {
                  title: window.sys_app_translate("Insurances List", lang),
                  path: "/insurance-requests/view-all",
                }
              : null,
          ],
        }
      : null,
    permissions[PSectionInsuranceRequests]["view-received"]
      ? {
          path: "/insurance-requests/view-received",
          title: window.sys_app_translate("Received Insurances", lang),
          subMenu: null,
          icon: "received-insurances",
        }
      : null,
    permissions[PSectionProfits] && permissions[PSectionProfits]["view-all"]
      ? {
          path: "/profits/view-all",
          title: window.sys_app_translate("Profits", lang),
          subMenu: null,
          icon: PSectionProfits,
        }
      : null,
    permissions[PSectionFinancialRequests]["view-all"]
      ? {
          path: PSectionFinancialRequests,
          title: window.sys_app_translate("Financial Requests", lang),
          subMenu: [
            {
              title: window.sys_app_translate("Financial Requests List", lang),
              path: "/financial-requests/view-all",
            },
            {
              path: "/financial-requests/view-exported",
              title: window.sys_app_translate(
                "Financial Activity Report v2",
                lang,
              ),
            },
            permissions[PSectionFinancialRequests][
              PermissionsFinancialRequestsViewBillingProfileReport
            ] && {
              path: "/financial-requests/credit-card",
              title: window.sys_app_translate("Credit Card Reports", lang),
            },
            permissions[PSectionFinancialRequests][
              PermissionsFinancialRequestsViewAgencyDiscountedPrices
            ] && {
              path: "/financial-requests/agency-discounted-prices",
              title: window.sys_app_translate(
                "Agency Discounted Prices",
                lang,
              ),
            },
          ],
          icon: PSectionFinancialRequests,
        }
      : null,
    permissions[PSectionBalanceRequests]["view-all"]
      ? {
          path: "balance",
          title: window.sys_app_translate("Balance", lang),
          subMenu: [
            {
              title: window.sys_app_translate("Balance Requests", lang),
              path: "/balance-requests/view-all",
            },
            {
              title: window.sys_app_translate("Debt Requests", lang),
              path: "/debt-requests/view-all",
            },
            {
              title: window.sys_app_translate("Balance Requests Report", lang),
              path: "/reports/incoming-money",
            },
          ],
          icon: "balance-requests",
        }
      : null,
    permissions[PSectionAgencies][PermissionAgenciesViewMainPageAll]
      ? {
          path: "agencies",
          title: window.sys_app_translate("Agencies", lang),
          subMenu: [
            permissions[PSectionAgencies]["create"] && {
              title: window.sys_app_translate("Add Agency", lang),
              path: "/agencies/create",
            },
            permissions[PSectionAgencies][
              PermissionAgenciesViewMainPageAll
            ] && {
              title: window.sys_app_translate("Agencies List", lang),
              path: "/agencies/view-all",
            },
            permissions[PSectionAgencies][
              PermissionAgenciesViewRatioHistory
            ] && {
              title: window.sys_app_translate("Ratio History", lang),
              path: "/agencies/ratio-history",
            },
          ],
          icon: "agencies",
        }
      : null,
    permissions[PSectionExpenses] && permissions[PSectionExpenses]["view-all"]
      ? {
          path: "expenses",
          title: window.sys_app_translate("Expenses", lang),
          icon: "expenses",
          subMenu: [
            permissions[PSectionExpenses]["create"] && {
              title: window.sys_app_translate("Add Expense", lang),
              path: "/expenses/create",
            },
            permissions[PSectionExpenses]["view-all"] && {
              title: window.sys_app_translate("Expenses List", lang),
              path: "/expenses/view-all",
            },
          ],
        }
      : null,
    permissions[PSectionLeads] && permissions[PSectionLeads]["view-all"]
      ? {
          path: PSectionLeads,
          title: window.sys_app_translate("Leads", lang),
          icon: PSectionLeads,
          subMenu: [
            permissions[PSectionLeads]["create"] && {
              title: window.sys_app_translate("Add Lead", lang),
              path: "/leads/create",
            },
            permissions[PSectionLeads]["view-all"] && {
              title: window.sys_app_translate("Leads List", lang),
              path: "/leads/view-all",
            },
          ],
        }
      : null,
    {
      path: "users",
      title: window.sys_app_translate("Users", lang),
      subMenu: null,
      icon: "users",
      subMenu: [
        permissions["users"]["create"] && {
          title: window.sys_app_translate("Add User", lang),
          path: "/users/create",
        },
        permissions["users"]["view-all"] && {
          title: window.sys_app_translate("Users List", lang),
          path: "/users/view-all",
        },
        permissions["roles"]["create"] && {
          title: window.sys_app_translate("Add User Role", lang),
          path: "/roles/create",
        },
        permissions["roles"]["view-all"] && {
          title: window.sys_app_translate("User Roles", lang),
          path: "/roles/view-all",
        },
        permissions["users"]["view-logs"] && {
          title: window.sys_app_translate("Users Logs", lang),
          path: "/users/view-logs",
        },
        permissions["users"]["profile"] && {
          title: window.sys_app_translate("Profile", lang),
          path: "/users/profile",
        },
        permissions["users"]["view-all-users-logged-devices"] && {
          title: window.sys_app_translate("Users Logged Devices", lang),
          path: "/users/view-all-users-logged-devices",
        },
      ],
    },
    {
      path: "automation",
      title: window.sys_app_translate("Automation Center", lang),
      subMenu: [
        permissions[PSectionBulkRatiosRequests]["create"] && {
          title: window.sys_app_translate("Create Bulk Ratios Request", lang),
          path: "/bulk-ratios-requests/create",
        },
        permissions[PSectionBulkRatiosRequests]["view-all"] && {
          title: window.sys_app_translate("Bulk Ratios List", lang),
          path: "/bulk-ratios-requests/view-all",
        },
        permissions[PSectionDebtSendingSchedules]["view-all"] && {
          title: window.sys_app_translate("DebtSending Schedules", lang),
          path: "/debtsending-schedules/view-all",
        },
        permissions[PSectionAgencyLists]["view-all"] && {
          title: window.sys_app_translate("Agency Lists", lang),
          path: "/agency-lists/view-all",
        },
        permissions["message-requests"]["create"] && {
          title: window.sys_app_translate("Add Message Request", lang),
          path: "/messaging",
        },
        permissions["message-requests"]["view-all"] && {
          title: window.sys_app_translate("Message Requests List", lang),
          path: "/message-requests/view-all",
        },
        // permissions[PSectionResidenceAppointments] &&
        //   permissions[PSectionResidenceAppointments]["view-all"] && {
        //     path: "/residence-appointments/view-all",
        //     title: window.sys_app_translate("Residence Appointments", lang),
        //     subMenu: null,
        //     icon: PSectionResidenceAppointments,
        //   },
      ],
      icon: "automation-center",
    },
    {
      path: "invoices",
      title: window.sys_app_translate("Invoices", lang),
      subMenu: [
        permissions["invoices-dashboard"] &&
          permissions["invoices-dashboard"]["view"] && {
            title: window.sys_app_translate("Invoices Dashboard", lang),
            path: "/invoices-dashboard/view",
          },
        permissions[PSectionSources] &&
          permissions[PSectionSources]["view-all"] && {
            title: window.sys_app_translate("Sources", lang),
            path: "/sources/view-all",
          },
        permissions[PSectionServices] &&
          permissions[PSectionServices]["view-all"] && {
            title: window.sys_app_translate("Services", lang),
            path: "/services/view-all",
          },
        permissions[PSectionServiceNames] &&
          permissions[PSectionServiceNames]["view-all"] && {
            title: window.sys_app_translate("Service Names", lang),
            path: "/service-names/view-all",
          },
        permissions[PSectionCustomers] &&
          permissions[PSectionCustomers]["view-all"] && {
            title: window.sys_app_translate("Customers", lang),
            path: "/customers/view-all",
          },
        permissions[PSectionInvoices] &&
          permissions[PSectionInvoices]["view-all"] && {
            title: window.sys_app_translate("Invoices", lang),
            path: "/invoices/view-all",
          },
        permissions[PSectionPayments] &&
          permissions[PSectionPayments]["view-all"] && {
            title: window.sys_app_translate("Payments", lang),
            path: "/payments/view-all",
          },
        permissions[PSectionPaymentMethods] &&
          permissions[PSectionPaymentMethods]["view-all"] && {
            title: window.sys_app_translate("Payment Methods", lang),
            path: "/payment-methods/view-all",
          },
        permissions[PSectionMoneyAccounts] &&
          permissions[PSectionMoneyAccounts]["view-all"] && {
            title: window.sys_app_translate("Money Accounts", lang),
            path: "/money-accounts/view-all",
          },
        permissions[PSectionMoneyAccounts] &&
          permissions[PSectionMoneyAccounts]["view-transactions"] && {
            title: window.sys_app_translate("Money Transactions", lang),
            path: "/money-accounts/view-transactions",
          },
      ],
      icon: "invoices",
    },
    permissions[PSectionSmsMessages] &&
    permissions[PSectionSmsMessages][PermissionSMSMessagesViewAll]
      ? {
          path: "/sms-messages/view-all",
          title: window.sys_app_translate("SMS Messages", lang),
          icon: "sms-messages",
        }
      : null,
    permissions[PSectionWhatsappDevices] &&
    permissions[PSectionWhatsappDevices][PermissionWhatsappDevicesViewAll]
      ? {
          path: "/whatsapp-devices/view-all",
          title: window.sys_app_translate("WhatsApp Devices", lang),
          icon: "whatsapp-devices",
        }
      : null,
    {
      path: "reports",
      title: window.sys_app_translate("Reports", lang),
      subMenu: [
        permissions[PSectionReports][PermissionReportAgencyActivity] && {
          title: window.sys_app_translate("Agency Activity", lang),
          path: "/reports/agency-activity",
        },
        permissions[PSectionReports][PermissionReportDiscountRates] && {
          title: window.sys_app_translate("Agency Ratios", lang),
          path: "/reports/agency-ratios",
        },
        permissions[PSectionReports][PermissionReportInsuranceCompanies] && {
          title: window.sys_app_translate("Insurance Companies", lang),
          path: "/reports/insurance-companies",
        },
        permissions[PSectionReports][PermissionReportAdvancedReports] && {
          title: window.sys_app_translate("Advanced Reports", lang),
          path: "/reports/advanced-reports",
        },
        permissions[PSectionReports][PermissionReportAdvancedReports] && {
          title: window.sys_app_translate("Insurances Comparison", lang),
          path: "/reports/insurances-comparison",
        },
        permissions[PSectionReports][PermissionReportAgenciesHasDebt] && {
          title: window.sys_app_translate("Agencies Who Has Debt", lang),
          path: "/reports/agencies-who-has-debt",
        },
      ],
      icon: "reports",
    },
    permissions["translations"] && permissions["translations"]["modify"]
      ? {
          path: "/translations",
          title: window.sys_app_translate("Translations", lang),
          subMenu: null,
          icon: "translations",
        }
      : null,
    permissions[PSectionAnnouncements] &&
    permissions[PSectionAnnouncements]["view-all"]
      ? {
          path: PSectionAnnouncements,
          title: window.sys_app_translate("Announcements", lang),
          subMenu: null,
          icon: PSectionAnnouncements,
          subMenu: [
            permissions[PSectionAnnouncements]["create"] && {
              title: window.sys_app_translate("Add Announcement", lang),
              path: "/announcements/create",
            },
            permissions[PSectionAnnouncements]["view-all"] && {
              title: window.sys_app_translate("Announcements List", lang),
              path: "/announcements/view-all",
            },
          ],
        }
      : null,

    is_super_admin ||
    (permissions[PSectionSettings] &&
      permissions[PSectionSettings][PermissionSettingsViewBankInfo])
      ? {
          path: "/options",
          title: window.sys_app_translate("Settings", lang),
          subMenu: [
            is_super_admin ||
            (permissions[PSectionSettings] &&
              permissions[PSectionSettings][PermissionSettingsViewBankInfo])
              ? {
                  path: "/options/banking-info",
                  title: window.sys_app_translate("Banking Info", lang),
                }
              : null,
            is_super_admin
              ? {
                  path: "/options/general",
                  title: window.sys_app_translate("General Settings", lang),
                }
              : null,
          ].filter(Boolean),
          icon: "settings",
        }
      : null,
  ];
};
